<template>
  <div class="layout-box">
    <LayoutHeader></LayoutHeader>
    <div class="secondary-content">
      <div class="reprint-box" style="height: 26.03%;border: 1px solid #374E7F;position: relative;"  v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.1)">
        <h3 style="position: absolute; top: 12px; left: 12px; font-size: 16px;">自控率详情</h3>
        <div id="alarm31" style="width: 100%; height: 100%;padding: 40px 15px 0 15px;box-sizing: border-box;">
          <el-table
            :data="alarmdata1"
            height="100%"
            size="mini"
            :header-row-style="{background:'none'}"
            :header-cell-style="{background:'none',padding:'6px 0',color:'#fff','border-bottom': '1px solid #2E88FF'}"
            row-class-name="self-owned-table"
            class="nonebak"
            style="width: 100%;color: #fff; font-size: 10px">
            <el-table-column
              prop="nameStr"
              label="名称">
            </el-table-column>
            <el-table-column
              prop="controlPer"
              label="自控率">
            </el-table-column>
            <el-table-column
              prop="enableNum"
              label="启用总数">
            </el-table-column>
            <el-table-column
              prop="automaticNum"
              label="自动回路数">
            </el-table-column>
            <el-table-column
              prop="handNum"
              label="手动回路数">
            </el-table-column>
            <el-table-column
              prop="abnormalNum"
              label="异常回路数">
            </el-table-column>
            <el-table-column
              prop="shieldNum"
              label="屏蔽回路数">
            </el-table-column>
            <el-table-column
              prop="deviation"
              label="偏差率">
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="reprint-box" style="height: 72.83%">
        <div class="rbox1" style="position: relative" v-loading="loading1" element-loading-background="rgba(0, 0, 0, 0.1)">
          <h3 style="position: absolute; top: 12px; left: 12px; font-size: 16px;">屏蔽回路</h3>
          <div id="alarm32" style="width: 100%; height: 100%;padding: 40px 15px 0 15px;box-sizing: border-box;">
            <el-table
              :data="alarmdata2"
              height="100%"
              size="mini"
              :header-row-style="{background:'none'}"
              :header-cell-style="{background:'none',padding:'6px 0',color:'#fff','border-bottom': '1px solid #2E88FF'}"
              row-class-name="self-owned-table"
              class="nonebak"
              style="width: 100%;color: #fff; font-size: 10px">
              <el-table-column
                prop="nameStr"
                label="回路名称">
              </el-table-column>
              <el-table-column
                prop="timeStr"
                label="屏蔽时间">
              </el-table-column>
              <el-table-column
                prop="description"
                label="描述">
              </el-table-column>
              <el-table-column
                prop="typeName"
                label="类型">
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="rbox2" style="border: none;justify-content: space-between;">
          <div style="position: relative" v-loading="loading2" element-loading-background="rgba(0, 0, 0, 0.1)">
            <div class="alarm3">
              <div>
                <span>当前自控投运率</span>
                <h2><countTo :startVal='0' :endVal='alarmdata3.controlPer || 0' :decimals="1" :duration='100'></countTo><em style="font-size: 21px;font-style: normal">%</em></h2>
              </div>
              <div>
                <span>回路总数</span>
                <h2><countTo :startVal='0' :endVal='alarmdata3.allNum || 0' :decimals="1" :duration='100'></countTo></h2>
              </div>
              <div>
                <span>屏蔽回路数</span>
                <h2><countTo :startVal='0' :endVal='alarmdata3.ignoreNum || 0' :decimals="1" :duration='100'></countTo></h2>
              </div>
              <div>
                <span>启用总数</span>
                <h2><countTo :startVal='0' :endVal='alarmdata3.enableNum || 0' :decimals="1" :duration='100'></countTo></h2>
              </div>
              <div>
                <span>手动回路数</span>
                <h2><countTo :startVal='0' :endVal='alarmdata3.handNum || 0' :decimals="1" :duration='100'></countTo></h2>
              </div>
              <div>
                <span>自动回路数</span>
                <h2><countTo :startVal='0' :endVal='alarmdata3.automaticNum || 0' :decimals="1" :duration='100'></countTo></h2>
              </div>
            </div>
          </div>
          <div style="position: relative" v-loading="loading3" element-loading-background="rgba(0, 0, 0, 0.1)">
            <h3 style="position: absolute; top: 12px; left: 12px; font-size: 16px;">自控率</h3>
            <div id="alarm33" style="width: 100%; height: 100%"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LayoutHeader from "../layout/production-alarm-header";
import {getTime} from "../../bll/utils";
import countTo from 'vue-count-to';

export default {
  name: 'ProductionAlarmAnalysis',
  props: {
    dataRefresh: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  components:{
    LayoutHeader,
    countTo
  },
  data () {
    return {
      loading:true,
      loading1:true,
      loading2:true,
      loading3:true,
      alarmdata1:[],
      alarmdata2:[],
      alarmdata3: {},
    }
  },
  mounted () {
    const $this=this
    setTimeout(function () {
      $this.getdata()
    },500)
    $this.dataRefresh.$ons('Refresh', () => {
      $this.getdata()
    })
  },
  methods:{
    getdata(){
      const $this=this
      const url = '/api-portal/ctrl/detail';
      $this.$api.post(url, {}, (response) => {
        let datas=response.data||''
        if(datas){
          $this.alarmdata1=datas.data
          this.loading=false
        }
      })
      const url2 = '/api-portal/ctrl/shield';
      $this.$api.post(url2, {}, (response) => {
        let datas=response.data||''
        if(datas){
          $this.alarmdata2=datas.data
          this.loading1=false
        }
      })
      const url3 = '/api-portal/ctrl/latestCtrl';
      $this.$api.post(url3, {}, (response) => {
        let datas=response.data||''
        if(datas){
          $this.alarmdata3=datas.data
          this.loading2=false
        }
      })
      const url4 = '/api-portal/ctrl/ctrlPer';
      $this.$api.post(url4, {}, (response) => {
        let datas=response.data||''
        if(datas){
          $this.alarmbarchart(datas.data)
          this.loading3=false
        }
      })
    },
    alarmbarchart (datas) {
      const myEchartst = this.$echarts.init(document.getElementById('alarm33'))
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          show: false
        },
        toolbox: {
          show: false
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          top: '18%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          // boundaryGap: false,
          axisLabel: {
            color: '#C1D3F4'
          },
          data: datas.dataX
        },
        yAxis: {
          type: 'value',
          splitLine: {show:false},
          axisLabel: {
            color: '#C1D3F4'
          }
        },
        series: [
          {
            name: datas.dataY.nameStr,
            type: 'bar',
            barMaxWidth:40,
            color:'#2C81F4',
            data: datas.dataY.value
          }
        ]
      }
      this.loading5 = false
      myEchartst.setOption(option)
    }
  }
}
</script>

<style scoped>
.layout-box {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1;
  top:0;
  left: 0;
  background: #060614 url("../../assets/bjs.png") no-repeat top/100%;
}

.secondary-content{
  width: 100%;
  height: calc(100% - 20px);
  padding: 0 10px;
  padding-top: 132px;
  display: flex;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
  flex-direction:column;
  color: #fff;
}

.reprint-box{
  box-sizing: border-box;
  height: 49.43%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.reprint-box>div{
  border: 1px solid #374E7F;
  box-sizing: border-box;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.rbox1{
  width: 42.5%;
}
.rbox2{
  width: 57%;
  flex-direction:column;
}
.rbox2>div{
  border: 1px solid #374E7F;
  box-sizing: border-box;
  height: 49.3%;
  width: 100%;
}

.el-table, .el-table__expanded-cell{
  background: none;
}

.nonebak:before{
  background: none;
}

.alarm3{
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap:wrap;
  justify-content:center
}

.alarm3>div{
  width: 33.3%;
  height: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.alarm3>div>span{
  font-size: 12px;
  color: #eDeDe4;
}

.alarm3>div h2{
  margin-top: 10px;
  font-size: 30px;
}

</style>



// WEBPACK FOOTER //
// src/views/secondary/production-alarm-analysis3.vue